var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebcallVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.358,
    height: 10.6,
    viewBox: "0 0 16.358 10.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bac0c2",
    stroke: "#bac0c2",
    strokeLinejoin: "round",
    strokeWidth: "0.6px",
    d: "M326.594,180a1.256,1.256,0,0,1-1.261-1.25v-7.5a1.256,1.256,0,0,1,1.261-1.25h10.085a1.256,1.256,0,0,1,1.261,1.25V172.6l2.117-1.749a.63.63,0,0,1,1.034.48v7.331a.63.63,0,0,1-1.034.48L337.94,177.4v1.353a1.256,1.256,0,0,1-1.261,1.25Zm-.63-8.75v7.5a.629.629,0,0,0,.63.625h10.085a.628.628,0,0,0,.63-.625v-7.5a.628.628,0,0,0-.63-.625H326.594A.629.629,0,0,0,325.964,171.25Zm11.976,2.168v3.164l2.521,2.083v-7.33Z",
    transform: "translate(-325.033 -169.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcallVideo);
export default __webpack_public_path__ + "static/media/webcall-video.6f52a48962973a5810676cebddb3ddf0.svg";
export { ForwardRef as ReactComponent };